import React, { useState } from 'react';
import { Cascader } from 'antd';
import styled from 'styled-components';

interface IProps {
  placeholder: string;
  onChange?: (val: any) => void;
  value: any;
  addressData: any;
}

const CascaderReset = (props: IProps) => {
  const changeAddress = (value: any) => {
    const address = {
      state: value[0],
      city: value[1],
      district: value[2],
    };
    props.onChange && props.onChange(address);
  };

  return (
    <>
      <Wrapper>
        {props.value?.state && <span className="title">{props.placeholder}</span>}
        <Cascader
          className="Cascader"
          fieldNames={{ label: 'name', value: 'name', children: 'children' }}
          options={props.addressData}
          value={props.value?.state ? [props.value?.state, props.value?.city, props.value?.district] : []}
          onChange={changeAddress}
          bordered={false}
          placeholder={props.placeholder}
        />
      </Wrapper>
    </>
  );
};

const Wrapper = styled.div`
  position: relative;
  height: 90px;
  //border-bottom: 1px solid #cfd2e3;
  .title {
    position: absolute;
    left: 11px;
    top: 11px;
    color: #b7bacb;
    font-size: 14px !important;
    z-index: 1;
  }
  .Cascader {
    width: 100%;
    height: 44px;
    margin: 20px auto 0 !important;
    color: #141c30 !important;
    font-size: 14px;
    //border-bottom: 1px solid #cfd2e3;
    background: transparent;
  }
  .ant-input {
    &::placeholder {
      color: #b7bacb;
      font-size: 14px;
      opacity: 1 !important;
    }
  }

  .ant-input {
    line-height: 33px;
  }
`;

export default CascaderReset;
